
import {
    styled,
} from "@l2r-front/l2r-ui"

const THUMBNAIL_WIDTH = 90
const CHIP_ICON_SIZE = 24

export const ThumbnailContainer = styled("div", { shouldForwardProp: (prop) => prop !== "hasThumbnail" })(({ hasThumbnail, theme }) => ({
    width: THUMBNAIL_WIDTH,
    height: "100%",
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: hasThumbnail ? "transparent" : theme.palette.secondary.main,
    flex: "0 0 auto",
}))

export const Thumbnail = styled("img")(() => ({
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
}))

export const TypeIcon = styled("img")(() => ({
    height: CHIP_ICON_SIZE,
    objectFit: "contain",
}))